import type { Settings } from '@pickpro/contracts';
import { writePreferences } from '../storage/preferences';

export const mirrorPreferences = (settings: Settings): void => {
  writePreferences({ locale: settings.locale, timezone: settings.timezone });
};
